module.exports = __webpack_public_path__ + "img/alnla-logo.e980f9e1.jpg";